import { ComponentType } from "react";
import { useSelector } from "react-redux";
import { TAX_SYSTEMS_CODES } from "@helpers/taxSystemsCodes";
import { RootState } from "@store/store";
import { RevisionExpedientePasos } from "@pages/producto/credito_simple/expediente_revision/RevisionExpedientePasos";
import { RevisionExpedienteFactoraje } from "@pages/producto/credito_simple/expediente_revision/RevisionExpedienteFactoraje";
import { RevisionExpedienteDefault } from "@pages/producto/credito_simple/expediente_revision/RevisionExpedienteDefault";
/**
 * Despacha a la pantalla de revisión correcta según el producto del solicitante.
 * Cualquier tipo desconocido cae a la pantalla de marcador de posición.
 */
const SCREEN_BY_TYPE: Partial<Record<string, ComponentType>> = {
  [TAX_SYSTEMS_CODES.MERCADER_PM]: RevisionExpedientePasos,
  [TAX_SYSTEMS_CODES.MERCADER_PFAE]: RevisionExpedientePasos,
  [TAX_SYSTEMS_CODES.MERCADER_PM_SIN_CIEC]: RevisionExpedientePasos,
  [TAX_SYSTEMS_CODES.MERCADER_PFAE_SIN_CIEC]: RevisionExpedientePasos,
  [TAX_SYSTEMS_CODES.FLUX_PM]: RevisionExpedienteFactoraje,
  [TAX_SYSTEMS_CODES.FLUX_PFAE]: RevisionExpedienteFactoraje,
};

export const RevisionExpediente = () => {
  const applicationType = useSelector((state: RootState) => state.register.application?.type);
  const Screen = (applicationType && SCREEN_BY_TYPE[applicationType]) || RevisionExpedienteDefault;
  return <Screen />;
};
